import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { translate } from 'react-i18next';
import Form from 'antd/lib/form';
import Button from 'antd/lib/button';
import Popover from 'antd/lib/popover';
import { Radio } from 'antd';
import Tabs from 'antd/lib/tabs';
import { connect } from 'react-redux';
import { EditorState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import {
  formatDateTime,
} from '../../../../common/utils/helpers';
import {
  createAccountMessageActions,
  selectMessagesFilter,
  fetchAccountAllMessagesActions,
  selectAllMessages,
} from '../../../account-management/ducks';

const mapStateToProps = state => ({
  messagesFilter: selectMessagesFilter(state),
  allMessages: selectAllMessages(state),
});

const mapDispatchToProps = {
  fetchAccountAllMessages: fetchAccountAllMessagesActions.request,
  addAccountMessage: createAccountMessageActions.request,
}


const TabPane = Tabs.TabPane;

@translate()
class CommunicationHelper extends Component {
  static propTypes = {
    account: PropTypes.object,
    messagesFilter: PropTypes.array.isRequired,
  };

  componentDidMount(){
    
    this.setState({
      messages: this.props.account.messages
    });
  }

  componentDidUpdate(props){
    if(this.props.account.id !== props.account.id){
        this.setState({
              messages: this.props.account.messages
            });
    }
    
  }

  state = {
    editorState: EditorState.createEmpty(),
    messages: [],
    isExternal: false,
  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  onCancel = () => {
    this.setState({
      editorState: EditorState.createEmpty()
    });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { editorState, isExternal } = this.state;
    const text = editorState.getCurrentContent();

    if (text.hasText()) {
      this.onSubmit({
        message: convertToRaw(text),
        isExternal
      });
      this.setState({
        editorState: EditorState.createEmpty()
      });
    }
  };

  onSubmit = message => {
    const { addAccountMessage , account, messagesFilter} = this.props;
    const accountId = account.id;
    const newOne = addAccountMessage({
      accountId,
      message,
      messagesFilter,
    });
    const transformedOne = {createdAt:new Date(),message:newOne.payload.message.message}
    const newMessages = this.state.messages;
    if (!message.isExternal) {
      newMessages.unshift(transformedOne);
    }
   
    this.setState({
      messages: newMessages,
      editorState: EditorState.createEmpty()
    });
    
  };

  onIsExternalChange = e => {
    this.setState({ isExternal: e.target.value });
  };

  callback = (key) => {
    if (key == 2) {
      const { account, fetchAccountAllMessages } = this.props;
      fetchAccountAllMessages({
        accountId: account.id,
      });
    }
  };

  render() {
    
    const { account, t } = this.props;
    const { editorState, messages, isExternal } = this.state;
    const usedMessages = messages || [];
    let allCommunication = 0;
    if(this.props.allMessages) {
      allCommunication = this.props.allMessages;
    }
    const content = (
    <div key={account.id} id={account.id}>
      <Tabs defaultActiveKey="1" onChange={this.callback} size='small'>
      <TabPane tab="Int. komunikácia" key="1">
        <div className="communicationPlaceholder">
        {usedMessages.map((value,index) => {
          return <div className="communicationPane" key={value.createdAt}>
                    <div>{formatDateTime(value.createdAt)}</div>
                    <div>{value.message.blocks[0].text}</div>
                </div>
        })}
        </div>
      </TabPane>

      <TabPane tab="Všetka komunikácia" key="2">
        <div className="communicationPlaceholder">
          { 
              !(allCommunication !== 0) ? <div></div> : allCommunication.map((value, index) => {
                return <div className="communicationPane" key={value.createdAt}>
                         <div>{formatDateTime(value.createdAt)}</div>
                         <div>{value.message.blocks[0].text}</div>
                       </div>
              })
          }
        </div>
      </TabPane>
      
      <TabPane tab="Nový záznam" key="3">
        <Form onSubmit={this.handleSubmit}>
          <Editor
            editorState={editorState}
            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editorClassName"
            onEditorStateChange={this.onEditorStateChange}
          />
          <div style={{ marginBottom: '30px' }}>
            <Radio.Group onChange={this.onIsExternalChange} value={isExternal}>
              <Radio value={false}>{t('Interná komunikácia')}</Radio>
              <Radio value={true}>{t('Externá komunikácia')}</Radio>
            </Radio.Group>
          </div>

          <Button size="default" type="primary" htmlType="submit">
            {t('Pridať')}
          </Button>
          <Button size="default" className="btn-inline" onClick={this.onCancel}>
            {t('Zmazať')}
          </Button>
        </Form>
      </TabPane>
    </Tabs>
    </div>
  );

    return (
        
        <Popover content={content} placement="bottomRight" title="Komunikácia" trigger="click">
          <span className="communicationMessage">
            <img src="/assets/singleMessage.svg"/>
          </span>
          <span className="numberOfLoans">{usedMessages.length}</span>
        </Popover>
        
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CommunicationHelper);



// WEBPACK FOOTER //
// ./src/features/account-management/components/profile/CommunicationHelper.js